// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const InformationMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_8404_999)">
            <path d="M10 6.29559H10.0093M10 9.07393V13.7045M18.335 10C18.335 14.6034 14.6034 18.335 10 18.335C5.39675 18.335 1.66504 14.6034 1.66504 10C1.66504 5.39675 5.39675 1.66504 10 1.66504C14.6034 1.66504 18.335 5.39675 18.335 10Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_8404_999">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
